"use client";

import { c as _c } from "react/compiler-runtime";
import { env } from "~/setup/env";
import type { JobadComponentProps } from "~/types/job";
import YouTubeEon from "../../jobadvideo/youtube-eon";
export default function CompanyEonGridsolutions(t0) {
  const $ = _c(11);
  const {
    job
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== job.data.company) {
    t2 = <h2 className="mb-10 font-bold text-4xl text-white md:text-5xl print:text-lg" data-source="job">{job.data.company}</h2>;
    $[1] = job.data.company;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== job.content.business) {
    t3 = <div className="text-lg text-white [&>p]:mb-4" dangerouslySetInnerHTML={{
      __html: job.content.business
    }} data-source="job" />;
    $[3] = job.content.business;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div><YouTubeEon thumbnailSrc="images/jobad/eongrid/youtube_thumbnail.jpg" videoId="apjjzlenkLk" /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="grid auto-cols-fr gap-x-8 gap-y-8 lg:grid-flow-col xl:gap-x-12">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <section className="outer-container py-container print:hidden" id="company" style={t1}><div className="inner-container">{t2}{t5}</div></section>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}